module.exports = __webpack_public_path__ + "img/Certification.2a43bc43.png";